import { render, staticRenderFns } from "./loadAnimation.vue?vue&type=template&id=663f7e46&scoped=true&"
import script from "./loadAnimation.vue?vue&type=script&lang=js&"
export * from "./loadAnimation.vue?vue&type=script&lang=js&"
import style0 from "./loadAnimation.vue?vue&type=style&index=0&id=663f7e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f7e46",
  null
  
)

export default component.exports